export const MessengerConstants = {
    LATEST_GRAPH_API_VERSION: 'v8.0',
    FB_ACCESS_TOKEN: 'blip-portal:fb_access_token',
};
